import GoogleMapsLoader from 'google-maps'
import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';
import Vue from 'vue';
const LocalEventBus = new Vue();

export default {
    name: 'CourseMap',
    props: ['courseId'],
    data() {
        return {
            map: null,
            marker: null,
            town: '',
            county: ''
        };
    },
    computed: {
        courseLocation() {
            return store.getters.getCourseLocation;
        }
    },
    methods: {
        showMap() {
            if (!this.map)
                GoogleMapsLoader.load((google) => {
                    this.initRegularMap(google)
                })
        },
        initRegularMap(google) {
            this.town = store.getters.getCourseTown;
            this.county = store.getters.getCourseCounty;

            var markLat = 0;
            var markLng = 0;

            var courseLocation = store.getters.getCourseLocation;
            if (courseLocation.longtitude) {
                markLat = courseLocation.longtitude;
            } else {
                markLat = -6.266155;
            }
            if (courseLocation.latitude) {
                markLng = courseLocation.latitude;
            } else {
                markLng = 53.350140;
            }

            const myLatlng = new window.google.maps.LatLng(53.350140, -6.266155)

            const mapOptions = {
                zoom: 8,
                center: myLatlng,
                scrollwheel: false // we disable de scroll over the map, it is a really annoing when you scroll through page
            }
            this.map = new window.google.maps.Map(document.getElementById('regularMap'), mapOptions)

            var markLatlng = new window.google.maps.LatLng(markLng, markLat)

            const marker = new window.google.maps.Marker({
                position: markLatlng,
                title: 'Regular Map!'
            });
            this.marker = marker;
            marker.setMap(this.map)
            this.map.setCenter(markLatlng);

            google.maps.event.addListener(this.map, 'click', function (event) {
                LocalEventBus.$emit("new_marker", event);
            });
        },
        saveData() {
            store.commit('setCourseTown', this.town);
            store.commit('setCourseCounty', this.county);

            EventBus.$emit("admin_save_course");
        }
    },
    created() {
        GoogleMapsLoader.KEY = process.env.GoogleApiKey;

        LocalEventBus.$on("new_marker", event => {
            if (this.marker) {
                this.marker.setMap(null);
                this.marker = null;
            }

            var marker = new google.maps.Marker({ position: event.latLng, map: this.map });
            this.marker = marker;
            store.commit('setCourseLocation', { longtitude: event.latLng.lng(), latitude: event.latLng.lat() });
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/course-map/course-map.js